import React from 'react';
import { objectArraySort, Flex, Avatar } from '@mss/mss-component-library';
import { TFunction } from 'i18next';
import RequestStatus from '../../../../common/RequestStatus';
import dateFormat from 'dateformat';

const columns = (t: TFunction) => [
  {
    title: '',
    dataIndex: '',
    key: '',
    width: 30,
    render: (record: any) => (
      <Flex h="center" v="center">
        <Avatar
          firstName={record.request_user_object?.first_name || ''}
          lastName={record.request_user_object?.last_name || ''}
        />
      </Flex>
    ),
  },
  {
    title: t('User'),
    dataIndex: 'user_name',
    key: 'user_name',
    sorter: (a: any, b: any) => objectArraySort(a, b, ['user_name']),
  },
  {
    title: t('Request date'),
    dataIndex: 'created_at',
    key: 'created_at',
    width: 165,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'created_at'),
    render: (record: any) =>
      record && dateFormat(record || '', 'mmmm dS, yyyy @ h:MM:ss TT'),
  },
  {
    title: t('Target asset'),
    dataIndex: ['asset_object', 'name'],
    key: 'asset_name',
    width: 165,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'asset_name'),
  },
  {
    title: t('Profile'),
    dataIndex: 'profile_name',
    key: 'profile_name',
    width: 165,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'profile_name'),
  },
  {
    title: t('Status'),
    dataIndex: 'status',
    key: 'status',
    width: 150,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'status'),
    render: (status: string) => <RequestStatus status={status} />,
  },
  {
    title: t('Handled by'),
    dataIndex: ['handled_by_user_name'],
    key: 'handled_by_user_name',
    width: 165,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'handled_by_user_name'),
    render: (record: any) => record || '',
  },
];

export default columns;
